import arquivoService from './arquivoService'

const recebeUrlValidaDownload = async (filePath: string): Promise<string> => arquivoService.recebeUrlValidaDownload(filePath)

export default {
  recebeUrlValidaDownload
}
